import React from 'react';
import { Row } from 'react-bootstrap';
import Card from './card';
import Jumbotron from './jumbotron';

const Home = () => (
  <>
    <Jumbotron />
    <Row>
      <Card md={12} title="Novo Endereço" warning>
        <p>Queridos pacientes e parceiros,</p>
        <p>
          Temos uma ótima novidade! Mudamos para oferecer ainda mais conforto, cuidado e qualidade no seu atendimento.
          Agora estamos em um novo endereço e também contamos com um novo canal de relacionamento, pensado para
          facilitar sua comunicação conosco.
        </p>
        <p>
          Novo canal de relacionamento:
          <br />
          <b>Telefone: (81) 3071-7590</b>
          <br />
          <b>WhatsApp: (81) 9 9251-7996</b>
        </p>
        <p>
          Novo endereço:
          <br />
          <b>Avenida Dezessete de Agosto, 312, 1⁰ Andar — Parnamirim, Recife-PE</b>
        </p>
        <p>
          Em nosso novo espaço, seguimos oferecendo todos os nossos serviços com a mesma dedicação:
          <ul>
            <li>Consultas especializadas em Alergia e Imunologia</li>
            <li>Testes diagnosticos (prick test, prick to prick, patch test)</li>
            <li>Teste de Provocação Oral com Alimentos e Medicamentos</li>
            <li>Imunoterapia sublingual e subcultânea</li>
            <li>Tratamentos individualizados, dentre outros cuidados</li>
          </ul>
        </p>
        <p>
          Estamos ansiosos para receber você e sua família em um ambiente renovado, planejado para proporcionar
          acolhimento, conforto e uma experiência de atendimento ainda melhor.
        </p>
      </Card>
    </Row>
    <Row>
      <Card title="Quem Somos" to="/empresa">
        Somos uma clinica especializada no diagnóstico e tratamento de todas doenças alergicas. Todos os nossos
        profissionais são especializados e titulados pela Associação Brasileira de Alergia e Imunopatologia - ASBAI.
      </Card>
      <Card title="Nossos Serviços" to="/servicos">
        Realizamos testes de leitura imediata (Prick test), Teste de Contato (Patch test) com extratos padronizados de
        alto padrão de qualidade. Além de teste de desencadeamento oral, padrão ouro no diagnóstico das doenças
        alérgicas.
      </Card>
      <Card title="Contato" to="/contato">
        Avenida Dezessete de Agosto, 312, 1⁰ Andar
        <br />
        Parnamirim | Recife-PE CEP: 52061-250
        <br />
        E-mail: contato@allergocentro.com.br
        <br />
        Telefone: (81) 3071-7590
        <br />
        WhatsApp: (81) 99251-7996
      </Card>
    </Row>
  </>
);

export default Home;
